import React from 'react';
import type { Doctor } from '../data/doctors';

interface DoctorCardProps {
  doctor: Doctor;
}

export default function DoctorCard({ doctor }: DoctorCardProps) {
  return (
    <div className="bg-white rounded-xl shadow-lg overflow-hidden transition-transform hover:scale-105">
      <div className="aspect-square overflow-hidden">
        <img 
          src={doctor.image} 
          alt={doctor.name}
          className="w-full h-full object-cover"
        />
      </div>
      <div className="p-6">
        <h3 className="text-xl font-semibold text-gray-900">{doctor.name}</h3>
        <p className="text-[#007FFF] font-medium">{doctor.title}</p>
        <p className="text-sm text-gray-600 mt-1">{doctor.specialty}</p>
        <p className="text-gray-600 mt-4 text-sm">{doctor.description}</p>
        <div className="mt-4">
          <h4 className="text-sm font-semibold text-gray-900 mb-2">Educație și Specializări:</h4>
          <ul className="text-sm text-gray-600 list-disc list-inside">
            {doctor.education.map((edu, index) => (
              <li key={index}>{edu}</li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}